import { render, staticRenderFns } from "./FmsReport.vue?vue&type=template&id=28a0b06e&scoped=true"
import script from "./FmsReport.vue?vue&type=script&lang=js"
export * from "./FmsReport.vue?vue&type=script&lang=js"
import style0 from "./FmsReport.vue?vue&type=style&index=0&id=28a0b06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0b06e",
  null
  
)

export default component.exports